import { render, staticRenderFns } from "./BackendNavbar.vue?vue&type=template&id=ebe15ae0&"
import script from "./BackendNavbar.vue?vue&type=script&lang=js&"
export * from "./BackendNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports